<template>
  <div class="pricing-information">
    <div class="pricing-information__sidebar">
      <ul>
        <li v-for="(item, index) in pricing"
            :key="index"
            class="pricing-information__item"
            :class="{'pricing-information__item--selected': isSelected(item)}">
          <component :is="isSelected(item) ? 'span' : 'a'"
                     href="javascript:;"
                     class="pricing-information__item-content"
                     @click="setSelected(item)">
            <span class="pricing-information__item-title">
              {{ item.title }}
            </span>
            <font-awesome-icon class="ml-2"
                               icon="chevron-right">
            </font-awesome-icon>
          </component>
        </li>
      </ul>
    </div>
    <div class="pricing-information__content"
         v-html="selectedContent">
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingInformation",
  props: {
    pricing: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      selectedInfo: null,
    };
  },
  computed: {
    selectedContent () {
      return this.pricing.find( x => x.title === this.selectedInfo )?.content;
    },
  },
  created () {
    if ( this.pricing && this.pricing.length ) {
      this.selectedInfo = this.pricing[0].title;
    }
  },
  methods: {
    setSelected ( item ) {
      this.selectedInfo = item.title;
    },
    isSelected ( item ) {
      return this.selectedInfo === item.title;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/index.less";

.pricing-information {
  display: flex;
  flex-direction: row;
  gap: 1rem;

  @media ( max-width: 991px ) {
    flex-wrap: wrap;
  }

  &__sidebar {
    flex-basis: 250px;
    flex-shrink: 0;

    @media ( max-width: 991px ) {
      flex-basis: 100%;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }

  &__item {
    border-bottom: 1px solid @color-accent-5;

    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 0;
      color: @color-accent-1-dark;
      text-decoration: none;
    }

    &--selected {
      span {
        color: @color-accent-2-dark !important;
      }
    }
  }
}
</style>
